import { createSlice } from '@reduxjs/toolkit';
import { initializeSuccess } from '../actions';

export interface WhiteLabelState {
  config: {
    schemaless?: {
      helpcenter?: {
        onlinePayment?: string;
      };
    };
  };
}

const initialState: WhiteLabelState = {
  config: {},
};

const whiteLabelSlice = createSlice({
  name: 'whiteLabel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initializeSuccess, (state, action) => {
      state.config = action.payload.whiteLabelConfig;
    });
  },
});

export const whiteLabelReducer = whiteLabelSlice.reducer;
